import { ChatMessage } from '../chat/ChatMessage'

export class ChatMessageWithDialog extends ChatMessage {
    public showDialog = false;
}
